

export let Translate = {
   en: {

      'ok': "OK",

      //signup.component
      'language': "Language",
      'SignUpNow': "Sign up now",
      'name': "Your Name",
      'email': "Email",
      'email_error': "Please enter a valid email address",
      "Phone": "Phone",
      'CompanyName': "Company/Store Name",
      'username': "Username",
      'pw': "Password",
      'pw_error': "At least 6 characters containing uppercase & lowercase letters and numbers",
      'domain_error': "only allow lower case, numbers or -",
      'SetUrl': "Set your site address (URL)",
      'signup': "Signup",
      'BackToLogin': "Back to Login",

      //signup.confirmed
      'WelcomeTo': "Welcome to",
      'EmailVerified': "Your email address has been verified.",
      'CanLogin': "You may now login to your",
      'CanLogin_acc': "account!",
      'GoToLogin': "Go to Login",





   },
   'zh_hk': {

      'ok': "確定",

      //signup.component
      'language': "語言",
      'SignUpNow': "立即註冊",
      'name': "你的名字",
      'email': "電郵地址",
      'email_error': "請輸入有效的電子郵件地址",
      "Phone": "電話",

      'CompanyName': "公司/商店名稱",
      'username': "用戶名稱",
      'pw': "帳號密碼",
      'pw_error': "密碼長度至少6個字元，當中最少包含1個大寫字母及1個數字。",
      'domain_error': "只容許細草英文字母，數字或-",
      'SetUrl': "設置您的網址 (URL)",
      'signup': "註冊",
      'BackToLogin': "回到登入頁面",

      //signup.confirmed
      'WelcomeTo': "歡迎使用",
      'EmailVerified': "您的電郵地址已通過驗證。",
      'CanLogin': "現在您可以登入您的 ",
      'CanLogin_acc': "帳戶！",
      'GoToLogin': "前往登入",

   },




}

export let _common = Object.assign({}, Translate.en)